import { DocumentFileType, documentFileTypeI18n } from '@/pages/documents/@x/document-file-type';

export const getFileDocumentType = (ext?: string) => {
  if (!ext) return null;

  const normalizedExt = ext.toLowerCase() as DocumentFileType;

  return {
    type: normalizedExt,
    label: documentFileTypeI18n[normalizedExt],
  };
};
